import { Box, Divider, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import useStore from '~/store';

export const InsuredInfo = () => {
  const [searchParams] = useSearchParams();

  // Detecta se estamos no fluxo de recuperação de cotação
  const quoteIdParam = searchParams.get('quote');
  const isQuoteRecoveryFlow = !!quoteIdParam;

  const { insured } = useStore((store) => ({
    insured: store.insured
  }));

  // Só exibe o componente se estiver no fluxo de recuperação e houver dados do segurado
  if (!isQuoteRecoveryFlow || !insured || (!insured?.social_name && !insured.name && !insured.document)) {
    return null;
  }

  // Função para formatar CPF
  const formatCPF = (cpf: string) => {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  return (
    <>
      <Typography variant="h6" fontWeight="bold">
        Segurado:
      </Typography>
      <Box sx={{ minWidth: '100%', mb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            padding: 1,
            margin: 0,
            width: '100%',
            textAlign: 'left'
          }}
        >
          {(insured?.social_name || insured.name) && (
            <Typography variant="body1" sx={{ mb: 0.5 }}>
              <strong>Nome:</strong> {insured?.social_name || insured.name}
            </Typography>
          )}
          {insured.document && (
            <Typography variant="body1">
              <strong>CPF:</strong> {formatCPF(insured.document)}
            </Typography>
          )}
        </Box>
      </Box>
      <Divider sx={{ width: '100%', mb: 2 }} />
    </>
  );
};
